import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { StatementOfInformationProps } from 'models/Listing';

import './StatementOfInformationCard.styles.scss';
import './StatementOfInformationCard.styles.responsive.scss';

type StatementOfInformationCardProps = {
  className?: string;
  statementOfInformation: StatementOfInformationProps;
};

const StatementOfInformationCard: React.FC<StatementOfInformationCardProps> = (
  props,
) => {
  const { className, statementOfInformation } = props;
  const { t } = useTranslation();

  const classes = classNames('statement-of-information-card', className);

  const tableContent = useMemo(
    () =>
      Object.entries(statementOfInformation).map(([key, value]) =>
        key === 'locationPostcode' || key === 'location' ? (
          value && (
            <tr key={key}>
              <td>{t(key)}</td>
              <td>{value || '-'}</td>
            </tr>
          )
        ) : (
          <tr key={key}>
            <td>{t(key)}</td>
            <td>{value || '-'}</td>
          </tr>
        ),
      ),
    [statementOfInformation, t],
  );

  return (
    <div className={classes}>
      <p>{t('statementOfInformation')}</p>
      <table>
        <tbody>{tableContent}</tbody>
      </table>
    </div>
  );
};

export default StatementOfInformationCard;
